// Size checks for downloaded audio (Flutter `_verifyCompletedDownload`,
// services/download_service.dart:105-119, and `_verifyLocalPlaybackFile`,
// providers/player_provider.dart:1397-1453; DL-017, ENG-002). Pure, shared by
// the download worker and the manager.

/** A download request with no response headers for this long is abandoned (and retried). */
export const HEADERS_TIMEOUT_MS = 30_000;
/** A download that receives no bytes for this long is abandoned (and retried). */
export const STALL_TIMEOUT_MS = 45_000;
/** A stored audio file smaller than this cannot be a real recording (Flutter `_minLocalAudioBytes`). */
export const MIN_LOCAL_AUDIO_BYTES = 1024;
const TOLERANCE_RATIO = 0.01;
const TOLERANCE_FLOOR_BYTES = 65_536;

/** Bytes a file may fall short of its expected size: 1 % of it, at least 64 KB. */
export function sizeTolerance(expectedBytes: number): number {
  return Math.max(Math.round(expectedBytes * TOLERANCE_RATIO), TOLERANCE_FLOOR_BYTES);
}

/** The file is shorter than expected beyond the tolerance (an unknown expected size, 0, never is). */
export function isIncomplete(actualBytes: number, expectedBytes: number): boolean {
  return expectedBytes > 0 && actualBytes + sizeTolerance(expectedBytes) < expectedBytes;
}

/** A stored audio file that is too small to play from start to end (under 1 KB, or incomplete). */
export function isUnplayableLocalFile(actualBytes: number, expectedBytes: number): boolean {
  return actualBytes < MIN_LOCAL_AUDIO_BYTES || isIncomplete(actualBytes, expectedBytes);
}
